import { GETCLIENTUSERDETAILS } from "../ENVIRONMENT";

// api for register new client
function registerForm(token, userdetails) {
  return fetch(GETCLIENTUSERDETAILS, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
    body: JSON.stringify(userdetails),
  });
}

function notificationregisterForm(token, userdetails) {
  return fetch(GETCLIENTUSERDETAILS + "?initialStep=true", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
    body: JSON.stringify(userdetails),
  });
}

export { registerForm,notificationregisterForm };
